import type { Ref, SelectHTMLAttributes } from "react";

import { select } from "~/components/Select.css";

export interface SelectProps extends SelectHTMLAttributes<HTMLSelectElement> {
  ref?: Ref<HTMLSelectElement>;
}

/** Thin wrapper around a native <select> in the Input box. Forwards every
 *  native prop; the options are the caller's children. */
export function Select({ className, ref, ...rest }: SelectProps) {
  const merged =
    className !== undefined && className.length > 0 ? `${select} ${className}` : select;
  return <select ref={ref} className={merged} {...rest} />;
}
